import { BaseRelationModel } from "./base-relation";
import {prop} from "../../decorators/property";

export class EURelationModel extends BaseRelationModel {

    @prop() public CelexNumber: string;
    @prop() public Date: Date;
    @prop() public ECLI: string;

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/eu-relation.ts